import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export interface ApiHealth {
  status: 'ok';
  uptimeSeconds: number;
  checks: { database: { status: 'up' | 'down'; latencyMs?: number } };
}

/** Harmless readiness probe against GET /api/v1/health. */
/** `pollMs` re-checks on an interval (the offline banner). */
export function useApiHealth(enabled = true, pollMs?: number) {
  return useQuery({
    queryKey: ['health'],
    queryFn: async ({ signal }) =>
      (await api.get<ApiHealth>('/health', { signal })).data,
    enabled,
    staleTime: pollMs ? 0 : 60_000,
    refetchInterval: pollMs,
    retry: false,
  });
}
